export default __webpack_public_path__ + "static/media/895.3d4dec59.gif";